module.exports = __webpack_public_path__ + "img/button_play.e214eab1.png";